function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3346"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3066",
  d: "M115.29 53.195c-.108-3.088.06-7.053.534-7.608 1.139-1.334 2.841-3.388 4.237-3.847 1.76-.579 12.763-1.356 14.509.3s2.784 5.891 2.989 8.488c.234 2.943.732 4.83-.076 4.968-2.964.5-13.912-.227-16.795-.369-2.584-.123-5.363-.915-5.398-1.932z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3067",
  d: "M137.581 50.588s10.841-.147 10.944.4c.375 2.028-2.663 10.727-4.1 10.758-3.914.088-23.82-1.872-28.11-2.636-1.1-.2-.525-4.857-.466-4.946",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3068",
  d: "M141.859 50.456l3.344-13.411s5.584 9.761 5.441 12.595-3.5 14.709-4.038 14.839c-1.186.29-25.378-4.7-25.378-4.7",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3069",
  d: "M145.277 37.226c-1.193-2.348-9.816-19.368-13.5-21.9-4.92-3.381-49.968-4.869-52.541-2.6-4.489 3.951-11.488 27.028-10.493 31.2.57 2.39 2.083 3.939 3.515 4.095 3.636.394 42.985 5.283 42.985 5.283",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3070",
  d: "M108.557 12.43c-3.748 7.588-9.868 30.68-11.025 38.54",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3071",
  d: "M59.996 60.632c-.08.014-.206 1.913.177 2.012a67.987 67.987 0 008.14.8 3.692 3.692 0 00.009-2.183 42.814 42.814 0 00-8.326-.629z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3326"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3072",
  d: "M95.5 65.711c-.1.016-.256 2.159.22 2.272a92.766 92.766 0 0010.113.9 3.8 3.8 0 00.011-2.466c-.186-.19-8.484-1.011-10.344-.706z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3073",
  d: "M61.43 60.449c.157-1.4.306-1.841.562-1.848.84-.019 6.041.365 6.287.756a5.355 5.355 0 01.089 1.932",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3327"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3074",
  d: "M97.283 65.502c.2-1.582.38-2.079.7-2.086 1.044-.021 7.506.412 7.812.853a5.523 5.523 0 01.111 2.182",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3075",
  d: "M61.153 62.855c.1 1.053.437 1.584.727 1.707a16.963 16.963 0 006.064.972c.26-.061.179-1.094.277-1.926",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3328"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3076",
  d: "M96.94 68.221c.125 1.19.543 1.789.9 1.928a23 23 0 007.534 1.1c.323-.069.223-1.235.344-2.175",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3077",
  d: "M213.686 77.187c3.12.346 38.039.365 38.039.365s-5.473 2.987-3.706 30.566c.076 1.186-23.563 1.771-26.257-.583s-.726-11.7-1.911-14.3c-1.953-4.281-7.893-8.422-7.846-9.976.164-5.339-.457-6.311 1.681-6.072z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3078",
  d: "M140.706 12.262c-.389-.523 26.5-2.94 29.137-1.983s1.529 1.147 4.7.873 35.691-1.038 39.056-1.209c.87-.044 1.782-1.289 2.234-1.29 2.062 0 12.4-.008 13.96.923 7.721 4.6 41.654 33.475 41.654 33.475s-109.533 6.835-109.775 6.553c-2.199-2.581-20.106-36.184-20.966-37.342z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3079",
  d: "M167.008 50.395c3.549.215 31.453-1.988 35.66-1.243s4.728 1.287 8.455.985 54.816-3.6 54.816-3.6l1.516-1.54 10.492-.947-6.488-1.057",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3080",
  d: "M207.758 118.069c-.981-.034 5.26 26.905 7.725 27.413 10.413 2.144 124.174-.557 132.911-21.9.508-1.238.055-17.737.055-17.737a46.067 46.067 0 00-4.136-2.686c-5.23 15.716-116.422 15.598-136.555 14.91z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3081",
  d: "M204.751 116.63c-2.8-14.149-50.42-57.826-51.957 16.029 0 .14-91.4-23.283-91.4-23.283s-5.9-50.246-3.414-54.742c4.048-7.31 13.6-43.8 19.032-47.068 2.843-1.712 16.056-3.881 24.051-4.341s104.654-6.689 127.18 3.985c10.13 4.8 39.67 30.8 45.48 35.948",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3329"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3082",
  d: "M204.826 116.657l3.449 1.393",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3083",
  d: "M159.404 45.526c8.039-.966 58.685-2.134 60.706-4.468s1.824-4.231 5.3-4.781 10.2-1.625 13.547-.171 10.34 5.243 13.44 5.041 17.01.356 17.01.356",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3084",
  d: "M260.275 117.623c-.178-9.055-1.055-28.975-.211-31.315.734-2.034 5.807-12.039 7.264-12.7 5.451-2.484 66.507-7.2 67.416-6.136 1.664 1.938 4.507 9.339 4.571 9.821 1.089 8.128.9 29.765.9 29.765",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3085",
  d: "M222.62 146.351c1.767 5.379 2.835 9.471 2.835 9.471l4.892 4.195s88.4.69 108.6-16.684c.515-.442 1.659-7.157 2.128-12.957",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3086",
  d: "M64.452 36.677l-57.71 3.105s-9.232 9.742-3.119 39.15l-.526 2.971 2.1 8.726s8.082 4.228 7.98 3.506c-5.128-36.24 22.169-35.217 27.79 11.146.161 1.325 20.432 3.58 20.432 3.58",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3087",
  d: "M13.056 39.519c7.7.91 48.947 4.526 48.947 4.526",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3088",
  d: "M26.292 40.734l37.446-1.7",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3089",
  d: "M5.644 41.558l55.408 5.48",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3090",
  d: "M2.587 50.455c1.685.014 2.867-.02 2.875.324.02.719-.085 5.628-.256 6.244a26.58 26.58 0 00-1.3 2.558c-.307 2.508.46 11.4.221 11.483l-1.777.086",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3091",
  d: "M182.874 10.991c3.856 2.336 3.569 5.356 9.017 5.3 3.952-.042 18.967-.521 19.659-1.578.439-.67-2.428-4.651-2.428-4.651",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3092",
  d: "M263.059 33.888c5.769-.377 6.674-.809 7.91.07.666.474 2.589 2.316 2.713 3.15.294 2 .726 6.327.726 6.327",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3093",
  d: "M211.725 13.767c4.457.319 7.65.078 9.19.909 3.278 1.77 12.574 8.091 12.574 8.091s-.217 5.15.385 5.806a35.673 35.673 0 007.712 5.6c.45.215 6.075-.921 6.754-.476.581.382 5.473 4.04 4.86 6.866",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3094",
  d: "M235.435 27.552c.028.379 6.367 4.892 6.8 4.777.7-.184 2.655-1.48 2.316-2.013-.371-.584-6.9-4.745-7.786-5.093-.523-.207-1.37 1.782-1.33 2.329z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3095",
  d: "M212.957 42.227c.856-3.469 8.895-10.348 15.444-6.444",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3330"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3096",
  d: "M210.644 42.485c1.545-6.053 11.457-14.364 19.716-7.037",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3097",
  d: "M278.079 43.894c9.52 1.276 53.619 12.341 56.975 15.427s5.076 6.606 5.291 9.433c.5 6.561 1.92 24.133 1.92 24.133a11.708 11.708 0 011.982 10.763",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3098",
  d: "M231.496 127.128a42.352 42.352 0 00-.387 8.025c.031.569 4.674 3.969 5.7 4.284 1.24.383 15.784.143 16.859-1.314.843-1.142 1-10.286.445-11.057-.683-.957-22.461-.588-22.617.062z",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3099",
  d: "M96.378 52.863c-2.107 4.944-2.432 4.538-2.513 10.861s2.694 52.706 2.694 52.706",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3100",
  d: "M3.24 78.315c-1.965.555-2.619.277-2.166 3.425s1.562 6.8 3.778 8.689",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3101",
  d: "M155.981 51.232c6.607.86 78.668 5.922 105.288 18.144",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3102",
  d: "M272.841 82.82c4.357-.014 46.29-3.977 58.508-6.425",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3331"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3103",
  d: "M269.897 88.9c10.7.272 57.257-3.922 62.437-5.428",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3332"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3104",
  d: "M269.758 96.511c12.616 1.522 55.549-3.352 63.068-5.791",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3333"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3105",
  d: "M272.775 103.571c14.017.687 51.189-3.939 58.708-6.379",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3334"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 105",
  cx: 22.776,
  cy: 39.476,
  rx: 22.776,
  ry: 39.476,
  transform: "rotate(-9.1 752.906 -895.251)",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3335"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 106",
  cx: 13.836,
  cy: 23.17,
  rx: 13.836,
  ry: 23.17,
  transform: "rotate(-9.09 852.422 -960.978)",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3336"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 107",
  cx: 11.699,
  cy: 27.317,
  rx: 11.699,
  ry: 27.317,
  transform: "rotate(-3.79 1242.203 -135.482)",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3337"
}, /*#__PURE__*/React.createElement("ellipse", {
  "data-name": "Ellipse 108",
  cx: 7.034,
  cy: 16.104,
  rx: 7.034,
  ry: 16.104,
  transform: "rotate(-3.79 1421.745 -214.913)",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3106",
  d: "M24.468 135.043c4.383 2.676 30.436 9.434 28.813-26.963",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3107",
  d: "M181.548 182.082c14.36 1.94 40.748 3.774 41.676-33.733",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3108",
  d: "M169.634 105.222c8.291-3.415 18.94-5.145 24.16-4.16",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3109",
  d: "M22.148 81.202c2.87-1.262 8.2-2.363 11.638-1.62",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3110",
  d: "M26.67 94.071c-5.17 6.194-7.165 21.9 2.548 29.324",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 3111",
  d: "M179.612 120.645c-12.316 10.183-11.868 42.712 8.7 42.925",
  fill: "none",
  stroke: "#aeb0b3",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}));

function SvgPassengerSideFrontQuarterBeautyShotGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309.649,
    height: 186.814,
    viewBox: "0 0 350 187"
  }, props), _ref);
}

export default SvgPassengerSideFrontQuarterBeautyShotGraphic;